import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-biaoge",
  "use": "icon-biaoge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-biaoge\">\r\n  <defs>\r\n    <style type=\"text/css\"></style>\r\n  </defs>\r\n  <path d=\"M64 96v832h896v-832H64z m608 208H896V448h-224V304z m-320 560H128v-147.2h224v147.2z m0-211.2H128V512h224v140.8z m0-204.8H128V304h224V448z m256 416h-192v-147.2h192v147.2z m0-211.2h-192V512h192v140.8z m0-204.8h-192V304h192V448z m288 416h-224v-147.2H896v147.2z m0-211.2h-224V512H896v140.8z\" p-id=\"2995\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/biaoge.svg
// module id = i35c
// module chunks = 54